import { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useRoles } from '../hooks/useRoles'

interface RequireAdminProps {
  children: ReactNode
}

/**
 * Route-level guard for admin-only pages. A Viewer who navigates to a wrapped
 * route by typing the URL is redirected back to the dashboard rather than
 * reaching the page. `ProtectedRoute` has already established that the user is
 * authenticated and has at least one role by the time this renders, so the only
 * decision here is admin-vs-not.
 *
 * This is defense-in-depth for UX only — the API independently enforces roles
 * via @require_admin. Never rely on this guard for actual authorization.
 */
export function RequireAdmin({ children }: RequireAdminProps) {
  const { isAdmin } = useRoles()

  if (!isAdmin) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}
